var map = {
	"./404@2x.png": "0e04",
	"./500@2x.png": "307d",
	"./aboutUs/bannerBlue.jpg": "3357",
	"./aboutUs/bannerGreen.jpg": "6094",
	"./aboutUs/bannerOrange.jpg": "d523",
	"./aboutUs/bannerRed.jpg": "6a34",
	"./assetToken.png": "da1c",
	"./avatarImg.png": "0f55",
	"./backCover/valuation.jpg": "a4aa",
	"./backgroundDV.jpg": "f165",
	"./bp/bannerBlue.jpg": "4bfa",
	"./bp/bannerGreen.jpg": "349f",
	"./bp/bannerOrange.jpg": "3918",
	"./bp/bannerRed.jpg": "aa29",
	"./bp/oneBlue.png": "3b49",
	"./bp/oneGreen.png": "d29a",
	"./bp/oneOrange.png": "6569",
	"./bp/oneRed.png": "32f1",
	"./contribution/arrows.png": "e7e5",
	"./contribution/contributionBlue.png": "b422",
	"./contribution/contributionGreen.png": "d5a7",
	"./contribution/contributionOrange.png": "37de",
	"./contribution/cornerMark.png": "a47a",
	"./dataEvaluation/filled/arc.png": "3d71",
	"./dataEvaluation/filled/arrows.png": "55a6",
	"./dataEvaluation/filled/circle.png": "1ce1",
	"./dataEvaluation/filled/leftBottom.png": "7460",
	"./dataEvaluation/filled/leftCenter.png": "b7d1",
	"./dataEvaluation/filled/leftTop.png": "1975",
	"./dataEvaluation/filled/navTitle.png": "daf6",
	"./dataEvaluation/filled/rightBottom.png": "a9d1",
	"./dataEvaluation/filled/rightTop.png": "80e1",
	"./dataEvaluation/filled/selectedLT.png": "eeff",
	"./dataEvaluation/filled/selectedRB.png": "1b31",
	"./dataEvaluation/filled/selectedRT.png": "8089",
	"./dataEvaluation/filled/softIndexBlue.png": "b072",
	"./dataEvaluation/filled/softIndexGreen.png": "ec0e",
	"./dataEvaluation/filled/softIndexOrange.png": "8f12",
	"./dataEvaluation/filled/unselectedLTicon.png": "dcf8",
	"./dataEvaluation/filled/unselectedRBicon.png": "6934",
	"./dataEvaluation/filled/unselectedRTicon.png": "044b",
	"./dataEvaluation/header.png": "cb81",
	"./dataEvaluation/jiantou-2.png": "21d8",
	"./dataEvaluation/my.png": "d911",
	"./dataEvaluation/report/equityStructureBase.png": "d0f6",
	"./dataEvaluation/report/icon1.png": "7e8c",
	"./dataEvaluation/report/icon10.png": "dea7",
	"./dataEvaluation/report/icon2.png": "754c",
	"./dataEvaluation/report/icon3.png": "b431",
	"./dataEvaluation/report/icon6.png": "f564",
	"./dataEvaluation/report/icon7.png": "aba3",
	"./dataEvaluation/report/icon8.png": "f67c",
	"./dataEvaluation/report/icon9.png": "98d3",
	"./dataEvaluation/report/opinionRating.png": "ce53",
	"./dataEvaluation/report/pageIndex_bg.jpg": "4f46",
	"./dataEvaluation/report/pageNumber.png": "99db",
	"./dataEvaluation/report/softIndicatorBase.png": "ce6d",
	"./dataEvaluation/report/statement-01@2x.png": "56f7",
	"./dataEvaluation/reportShow_bg.png": "e00b",
	"./dataEvaluation/right.png": "a846",
	"./dataResource/addIcon.png": "51b3",
	"./dataResource/addIconHover.png": "26a8",
	"./dataResource/contributionBlue.png": "8293",
	"./dataResource/contributionGreen.png": "f490",
	"./dataResource/contributionOrange.png": "7274",
	"./dataResource/dataType.png": "1bd0",
	"./dataResource/dataTypeSelected.png": "5504",
	"./dataResource/dataTypeSelectedShort.png": "79f4",
	"./dataResource/dataTypeShort.png": "d59d",
	"./dataResource/del.png": "7b1c",
	"./dataResource/delHover.png": "ac12",
	"./dataResource/fillout.png": "8969",
	"./dataResource/filloutHover.png": "02ae",
	"./dataResource/incomeBlue.png": "1c7b",
	"./dataResource/incomeGreen.png": "f50f",
	"./dataResource/incomeOrange.png": "c8fc",
	"./dataResource/netProfitBlue.png": "b5cd",
	"./dataResource/netProfitGreen.png": "601e",
	"./dataResource/netProfitOrange.png": "137e",
	"./dataResource/noInformation.png": "d19a",
	"./dataResource/redactIcon.png": "b579",
	"./dataResource/redactIconHover.png": "8459",
	"./dataResource/resourceBlue.png": "6d6d",
	"./dataResource/resourceGreen.png": "9463",
	"./dataResource/resourceOrange.png": "e0c4",
	"./dataResource/valuationResult.png": "1847",
	"./dataResource/valuationResult2.png": "388e",
	"./dataValutaion/FAQ.png": "2b82",
	"./dataValutaion/accomplish.png": "e4bb",
	"./dataValutaion/arc.png": "3ad1",
	"./dataValutaion/arrows.png": "5d8e",
	"./dataValutaion/back.png": "96715",
	"./dataValutaion/back2.png": "cf90",
	"./dataValutaion/backHover.png": "dd93",
	"./dataValutaion/backHover2.png": "e64a",
	"./dataValutaion/base.png": "bd2d",
	"./dataValutaion/baseIcon.png": "795b",
	"./dataValutaion/close.png": "d8c5",
	"./dataValutaion/contribution.png": "bab5",
	"./dataValutaion/contributionIcon.png": "80f7",
	"./dataValutaion/dataTitle.png": "321f",
	"./dataValutaion/explanationNounsIcon.png": "d056",
	"./dataValutaion/fillinTitle.png": "0e53",
	"./dataValutaion/finance.png": "b1d1",
	"./dataValutaion/financeIcon.png": "6781",
	"./dataValutaion/leftBottom.png": "3765",
	"./dataValutaion/leftTop.png": "1302",
	"./dataValutaion/nextStep.png": "8ccd",
	"./dataValutaion/nextStep2.png": "f217",
	"./dataValutaion/nextStepHover.png": "5166",
	"./dataValutaion/nextStepHover2.png": "06de",
	"./dataValutaion/reportIcon.png": "5d11",
	"./dataValutaion/reportSilde.png": "7001",
	"./dataValutaion/rightBottom.png": "470f",
	"./dataValutaion/rightTop.png": "6bf4",
	"./dataValutaion/search.png": "8f76",
	"./dataValutaion/selectedBase.png": "eacd",
	"./dataValutaion/selectedBaseIcon.png": "7399",
	"./dataValutaion/selectedContribution.png": "89ba",
	"./dataValutaion/selectedContributionIcon.png": "e55e",
	"./dataValutaion/selectedFinance.png": "ee56",
	"./dataValutaion/selectedFinanceIcon.png": "43aa",
	"./dataValutaion/selectedReportIcon.png": "0f21",
	"./dataValutaion/selectedReportSilde.png": "492a",
	"./dataValutaion/selectedSoft.png": "1769",
	"./dataValutaion/selectedSoftIcon.png": "abf8",
	"./dataValutaion/soft.png": "0d0d",
	"./dataValutaion/softIcon.png": "42b7",
	"./examine/failAudit.png": "58ac",
	"./examine/icon_audit_date.png": "43c2",
	"./examine/icon_audit_title.png": "9f92",
	"./examine/newTitle.png": "ab9e",
	"./examine/title.png": "8399",
	"./examine/titleBG.png": "a22f",
	"./examine/underReview.png": "1d9a",
	"./examine/viewBG.png": "ffc3",
	"./figure/NSNumber/0.png": "3745",
	"./figure/NSNumber/1.png": "e9b3",
	"./figure/NSNumber/11.png": "271b",
	"./figure/NSNumber/12.png": "27da",
	"./figure/NSNumber/13.png": "e537",
	"./figure/NSNumber/2.png": "91e3",
	"./figure/NSNumber/3.png": "d0d8",
	"./figure/NSNumber/4.png": "c299",
	"./figure/NSNumber/5.png": "77e6",
	"./figure/NSNumber/6.png": "dd1f",
	"./figure/NSNumber/7.png": "87a1",
	"./figure/NSNumber/8.png": "ec26",
	"./figure/NSNumber/9.png": "18c2",
	"./fillin/baocun.png": "f609",
	"./fillin/baocun2.png": "85e0",
	"./fillin/baocunHover.png": "c3d7",
	"./fillin/baocunHover2.png": "a0a0",
	"./fillin/cach.png": "eb28",
	"./fillin/cancel.png": "b5c8",
	"./fillin/cancelHover.png": "1d41",
	"./fillin/cguanbi.png": "ebfa",
	"./fillin/completion.png": "dfd3",
	"./fillin/dataTypeSelected.png": "5df1",
	"./fillin/erweima.png": "0786",
	"./fillin/fillinTitle.png": "2e54",
	"./fillin/fou.png": "af01",
	"./fillin/guanbi.png": "200f",
	"./fillin/lingdang.png": "19f3",
	"./fillin/navLeftBottom.png": "9d91",
	"./fillin/navLeftTop.png": "645a",
	"./fillin/navRightBottom.png": "f31b",
	"./fillin/navRightTop.png": "bd86",
	"./fillin/payClose.png": "da5a",
	"./fillin/paymentCorrelation2.png": "ef6a",
	"./fillin/saveBtn.png": "b7a9",
	"./fillin/saveBtnHover.png": "09aa",
	"./fillin/selectedCompletion.png": "918a",
	"./fillin/selectedLB.png": "b1f4",
	"./fillin/selectedLT.png": "807e3",
	"./fillin/selectedRB.png": "98de",
	"./fillin/selectedRT.png": "c96b",
	"./fillin/shell.png": "c458",
	"./fillin/shi.png": "6ab4",
	"./fillin/success.png": "2a46",
	"./fillin/tishi.png": "1229",
	"./fillin/tishitanhchuang.png": "06ee",
	"./fillin/unsave.png": "8b55",
	"./fillin/unselectedLBicon.png": "182b",
	"./fillin/unselectedLBottom.png": "da58",
	"./fillin/unselectedLTicon.png": "8b76",
	"./fillin/unselectedLTop.png": "bda8",
	"./fillin/unselectedRBicon.png": "04f5",
	"./fillin/unselectedRBottom.png": "d427",
	"./fillin/unselectedRTicon.png": "ae64",
	"./fillin/unselectedRTop.png": "fc52",
	"./fillin/一键生成报告低.png": "9e87",
	"./fillin/一键生成报告弹窗.png": "6785",
	"./fillin/主体.png": "9ff0",
	"./fillin/价格@2x.png": "82b3",
	"./fillin/利润表.png": "c8a7",
	"./fillin/发票@2x.png": "96e1",
	"./fillin/图灵.png": "3790",
	"./fillin/基本信息背景.png": "58d4",
	"./fillin/导航栏右侧内.png": "369b",
	"./fillin/导航栏右侧外.png": "369b0",
	"./fillin/导航栏右侧外11.png": "c401",
	"./fillin/导航栏左侧内.png": "369b04",
	"./fillin/导航栏左侧外.png": "369b04d",
	"./fillin/形状 535@2x.png": "b13e",
	"./fillin/按钮保存浅色.png": "7847",
	"./fillin/按钮保存蓝色.png": "78476",
	"./fillin/按钮关闭浅色.png": "e852",
	"./fillin/按钮关闭蓝色.png": "e8522",
	"./fillin/提示.png": "7c81",
	"./fillin/暂无估值记录.png": "bc41",
	"./fillin/科技框.png": "3201",
	"./fillin/组 20@2x.png": "d74f",
	"./fillin/软性指标@2x.png": "3a42",
	"./fillin/错误.png": "cb99",
	"./finance/accountantBlue.png": "fb0c",
	"./finance/accountantGreen.png": "9626",
	"./finance/accountantOrange.png": "81d2",
	"./finance/annualForecastBlue.png": "1c55",
	"./finance/annualForecastGreen.png": "afa2",
	"./finance/annualForecastOrange.png": "5fbc",
	"./finance/arrows.png": "7ada",
	"./finance/assetBlue.png": "bbaa",
	"./finance/assetGreen.png": "9d0e",
	"./finance/assetOrange.png": "2ff1",
	"./finance/badge.png": "343a",
	"./finance/carryingValueBlue.png": "db1e",
	"./finance/carryingValueGreen.png": "5fbd",
	"./finance/carryingValueOrange.png": "519e",
	"./finance/close.png": "7239",
	"./finance/dataAssetBlue.png": "3ab0",
	"./finance/dataAssetGreen.png": "f9a2",
	"./finance/dataAssetOrange.png": "c0c7",
	"./finance/del.png": "a9fe",
	"./finance/hint.png": "5115",
	"./finance/incomeBlue.png": "a52e",
	"./finance/incomeForecastBlue.png": "c860",
	"./finance/incomeForecastGreen.png": "83b4",
	"./finance/incomeForecastOrange.png": "ef10",
	"./finance/incomeGreen.png": "ceb2",
	"./finance/incomeOrange.png": "33ac",
	"./finance/line.png": "ea83",
	"./finance/netProfitBlue.png": "8a10",
	"./finance/netProfitGreen.png": "c428",
	"./finance/netProfitOrange.png": "91ec",
	"./finance/profitBlue.png": "02ba",
	"./finance/profitGreen.png": "a268",
	"./finance/profitOrange.png": "4bb0",
	"./finance/select.png": "2c8e",
	"./financialEarlyWarning/banner.jpg": "2c8a",
	"./financialEarlyWarning/pageIndex_bg.png": "b131",
	"./flowLogo.png": "f6aa",
	"./footer/companyAddress.png": "31c2",
	"./footer/onlineConsult.png": "0950",
	"./footer/serviceTel.png": "a236",
	"./footer/wechartCode.png": "2058",
	"./footer/wechatNumber.png": "27e5",
	"./footerSignUp/background.png": "1ef3",
	"./footerSignUp/registerBlue.jpg": "5b8d",
	"./footerSignUp/registerGreen.jpg": "9c69",
	"./footerSignUp/registerOrange.jpg": "900a",
	"./footerSignUp/registerRed.jpg": "e11f",
	"./growthDiagnosis/financialResult_1.png": "006b",
	"./growthDiagnosis/financialResult_2.png": "2368",
	"./growthDiagnosis/financialResult_3.png": "fc8a",
	"./growthDiagnosis/financialResult_4.png": "b4de",
	"./growthDiagnosis/scoreLow.svg": "3869",
	"./guzhi/agreementBg.png": "d14c",
	"./guzhi/agreement_re.png": "8dd1",
	"./guzhi/close.png": "8d4e",
	"./guzhi/icon_alipay.png": "d115",
	"./guzhi/icon_wechat.png": "4d2f",
	"./guzhi/payBannerBlue.jpg": "5c99",
	"./guzhi/payBannerGreen.jpg": "a158",
	"./guzhi/payBannerOrange.jpg": "4078",
	"./guzhi/payBannerRed.jpg": "8845",
	"./guzhiReport.png": "82ba",
	"./home/16.png": "73a8",
	"./home/DVlogo.svg": "c681",
	"./home/analyse/oneBlue.jpg": "1546",
	"./home/analyse/oneGreen.jpg": "1acb",
	"./home/analyse/oneOrange.jpg": "6d9e",
	"./home/analyse/oneRed.jpg": "7b6b",
	"./home/analyse/two1Blue.png": "c59a",
	"./home/analyse/two1Green.png": "de38",
	"./home/analyse/two1Orange.png": "d1c0",
	"./home/analyse/two1Red.png": "e711",
	"./home/analyse/two2Blue.png": "2360",
	"./home/analyse/two2Green.png": "2b2d",
	"./home/analyse/two2Orange.png": "c17d",
	"./home/analyse/two2Red.png": "21b5",
	"./home/analyse/twoBJBlue.png": "21e8",
	"./home/appraisement.png": "b398",
	"./home/appraisementHover.png": "145b",
	"./home/bannerBlue.jpg": "f208",
	"./home/bannerGreen.jpg": "efca",
	"./home/bannerLabel1Blue.png": "7c47",
	"./home/bannerLabel1Green.png": "b3d1",
	"./home/bannerLabel1Orange.png": "7fa6",
	"./home/bannerLabel1Red.png": "cc39",
	"./home/bannerLabel2Blue.png": "ca6c",
	"./home/bannerLabel2Green.png": "a234",
	"./home/bannerLabel2Orange.png": "1d18",
	"./home/bannerLabel2Red.png": "9ebf",
	"./home/bannerLabel3Blue.png": "a6e2",
	"./home/bannerLabel3Green.png": "66b0",
	"./home/bannerLabel3Orange.png": "9dbb",
	"./home/bannerLabel3Red.png": "4943",
	"./home/bannerOrange.jpg": "4aaf",
	"./home/bannerRed.jpg": "8c24",
	"./home/bpBJBlue.jpg": "54a3",
	"./home/bpBJGreen.jpg": "80f3",
	"./home/bpBJOrange.jpg": "313ec",
	"./home/bpBJRed.jpg": "5105",
	"./home/bpBlue.png": "c6f9",
	"./home/bpGreen.png": "0025",
	"./home/bpOrange.png": "d59b",
	"./home/bpRed.png": "f04c",
	"./home/data/four1Blue.jpg": "c322",
	"./home/data/four1Green.jpg": "aa90",
	"./home/data/four1Orange.jpg": "ec28",
	"./home/data/four1Red.jpg": "df30",
	"./home/data/four2Blue.jpg": "ec8d",
	"./home/data/four2Green.jpg": "8863",
	"./home/data/four2Orange.jpg": "d03f",
	"./home/data/four2Red.jpg": "8d68",
	"./home/data/four3Blue.jpg": "d599",
	"./home/data/four3Green.jpg": "7111",
	"./home/data/four3Orange.jpg": "d6e1",
	"./home/data/four3Red.jpg": "ebb7",
	"./home/data/four4Blue.jpg": "ea2f",
	"./home/data/four4Green.jpg": "f8fb",
	"./home/data/four4Orange.jpg": "b6f5",
	"./home/data/four4Red.jpg": "d638",
	"./home/data/oneBlue.jpg": "78e1",
	"./home/data/oneGreen.jpg": "8051",
	"./home/data/oneOrange.jpg": "5019",
	"./home/data/oneRed.jpg": "2755",
	"./home/data/three1Blue.jpg": "ad86",
	"./home/data/three1Green.jpg": "4310",
	"./home/data/three1Orange.jpg": "d517",
	"./home/data/three1Red.jpg": "6d67",
	"./home/data/three2Blue.jpg": "14fb",
	"./home/data/three2Green.jpg": "55bf",
	"./home/data/three2Orange.jpg": "3c01",
	"./home/data/three2Red.jpg": "3fca",
	"./home/data/three3Blue.jpg": "c3f9",
	"./home/data/three3Green.jpg": "10b8",
	"./home/data/three3Orange.jpg": "7e80",
	"./home/data/three3Red.jpg": "22d3",
	"./home/dataAccuracy.png": "3d00",
	"./home/dataFeature.png": "1ef8",
	"./home/dataFlow.png": "a218",
	"./home/dataIntegrity.png": "7a076",
	"./home/dataLegalization.png": "43e4",
	"./home/dataNormalization.png": "be71",
	"./home/dataQuality.png": "ba1f",
	"./home/dataRisk.png": "bfb6",
	"./home/dataSecurity.png": "e29c",
	"./home/diagnose/oneBlue.jpg": "5c69",
	"./home/diagnose/oneGreen.jpg": "e097",
	"./home/diagnose/oneOrange.jpg": "250c",
	"./home/diagnose/oneRed.jpg": "7e20",
	"./home/diagnose/threeBlue.jpg": "3f7f",
	"./home/diagnose/threeGreen.jpg": "4665",
	"./home/diagnose/threeOrange.jpg": "bbac",
	"./home/diagnose/threeRed.jpg": "ee8a",
	"./home/diagnose/twoBlue.jpg": "8ce8",
	"./home/diagnose/twoGreen.jpg": "e4dc",
	"./home/diagnose/twoOrange.jpg": "1943",
	"./home/diagnose/twoRed.jpg": "63fb",
	"./home/digitization.png": "a49f",
	"./home/digitizationRed.jpg": "5793",
	"./home/funds/oneBlue.jpg": "ec78",
	"./home/funds/oneGreen.jpg": "da85",
	"./home/funds/oneOrange.jpg": "a214",
	"./home/funds/oneRed.jpg": "1a5f",
	"./home/funds/three1Blue.jpg": "af8c",
	"./home/funds/three1Green.jpg": "1547",
	"./home/funds/three1Orange.jpg": "caa0",
	"./home/funds/three1Red.jpg": "4a2c",
	"./home/funds/three2Blue.jpg": "a3c3",
	"./home/funds/three2Green.jpg": "db42",
	"./home/funds/three2Orange.jpg": "972d",
	"./home/funds/three2Red.jpg": "aaba",
	"./home/funds/three3Blue.jpg": "1c5a",
	"./home/funds/three3Green.jpg": "967e",
	"./home/funds/three3Orange.jpg": "0c32",
	"./home/funds/three3Red.jpg": "fee8",
	"./home/funds/two1Blue.jpg": "8833",
	"./home/funds/two1Green.jpg": "330b",
	"./home/funds/two1Orange.jpg": "641f",
	"./home/funds/two1Red.jpg": "7ef7",
	"./home/funds/two2Blue.jpg": "b663",
	"./home/funds/two2Green.jpg": "9d87",
	"./home/funds/two2Orange.jpg": "b137",
	"./home/funds/two2Red.jpg": "5c6a",
	"./home/groundFloor.png": "06aa",
	"./home/header.png": "16b1",
	"./home/headerCenter.png": "0d1e",
	"./home/headerCenterLeft.png": "a4f4",
	"./home/headerCenterRight.png": "bab4",
	"./home/homeBackground.png": "358e",
	"./home/homeIcon.png": "d735",
	"./home/loginIcon.png": "dc7d",
	"./home/mlEstimationMethod.png": "c609",
	"./home/numberQuotient.png": "fb48",
	"./home/numberQuotientRed.jpg": "3c7d",
	"./home/partnerBlue.jpg": "de79",
	"./home/partnerGreen.jpg": "bde9",
	"./home/partnerOrange.jpg": "2dfd",
	"./home/partnerRed.jpg": "1bcd",
	"./home/pedestal.png": "972c",
	"./home/pedestalIcon.png": "e9d4",
	"./home/revenueContribution.png": "820a",
	"./home/scaleData.png": "6072",
	"./home/streamer.png": "9d22",
	"./home/systemIcon1.png": "a64a",
	"./home/systemIcon2.png": "9136d",
	"./home/systemIcon3.png": "173f",
	"./home/valuation/four1Blue.png": "5c51",
	"./home/valuation/four1Green.png": "c1c9",
	"./home/valuation/four1Orange.png": "47ae",
	"./home/valuation/four1Red.png": "b2e2",
	"./home/valuation/four2Blue.png": "9cc5",
	"./home/valuation/four2Green.png": "96db",
	"./home/valuation/four2Orange.png": "35ce",
	"./home/valuation/four2Red.png": "939b",
	"./home/valuation/four3Blue.png": "412c",
	"./home/valuation/four3Green.png": "a82c",
	"./home/valuation/four3Orange.png": "d6bb",
	"./home/valuation/four3Red.png": "4b07",
	"./home/valuation/four4Blue.png": "6c96",
	"./home/valuation/four4Green.png": "8305",
	"./home/valuation/four4Orange.png": "a112",
	"./home/valuation/four4Red.png": "8e26",
	"./home/valuation/oneBlue.jpg": "d3dd",
	"./home/valuation/oneGreen.jpg": "13cb",
	"./home/valuation/oneOrange.jpg": "9962",
	"./home/valuation/oneRed.jpg": "ffa9",
	"./home/valuation/three1Blue.png": "faa8",
	"./home/valuation/three1Green.png": "9055",
	"./home/valuation/three1Orange.png": "5884",
	"./home/valuation/three1Red.png": "d01d",
	"./home/valuation/three2Blue.png": "1db9",
	"./home/valuation/three2Green.png": "a607",
	"./home/valuation/three2Orange.png": "e60f",
	"./home/valuation/three2Red.png": "2c7f",
	"./home/valuation/three3Blue.png": "bac4",
	"./home/valuation/three3Green.png": "0ab1",
	"./home/valuation/three3Orange.png": "62c5",
	"./home/valuation/three3Red.png": "3ad7",
	"./home/valuationIcon.png": "cb79",
	"./homeLogo.png": "e4f1",
	"./index4.0/newIcon.gif": "eee1",
	"./login/@2x.png": "42c7",
	"./login/@2x.svg": "a5732",
	"./login/@2x_.svg": "ba48",
	"./login/agree.png": "9f23",
	"./login/arrowBottom.png": "28b1",
	"./login/arrowTop.png": "1746",
	"./login/backgroundImage.jpg": "c2af",
	"./login/backgroundImageRed.jpg": "5145",
	"./login/chinaLogo4@2x.png": "e1777",
	"./login/disagree.png": "cfe7",
	"./login/login-img.jpg": "4208",
	"./login/login-img5@2x.png": "54bb",
	"./login/logintu.png": "f0e7",
	"./login/logo-04.svg": "2f42",
	"./login/logo-06.png": "d3a1",
	"./login/logo-06.svg": "6706",
	"./login/logo@2x.png": "7fac7",
	"./login/logo@3x.png": "56b9",
	"./login/logoWhile.png": "4e4e",
	"./login/logoWhite@2x.png": "2d68",
	"./login/logo_06.png": "176c",
	"./login/registerPrompt.png": "65f5",
	"./login/wode.png": "f1e3",
	"./logo-08.svg": "790d",
	"./logo/flowGroupWhite.png": "f651",
	"./logo/flowLogo.png": "e72d",
	"./logo/flowWisdomBlack.png": "2d01",
	"./logo/flowWisdomWhite.png": "2c58",
	"./logo/wiseEstimateWatermark.png": "1d5c",
	"./logo/wiseEstimateWatermarkMobile.png": "2193",
	"./logoData.png": "1614",
	"./logo_06.png": "0f7ce",
	"./mobileClient/close.png": "3ac8",
	"./mobileClient/leibie.svg": "d5fa",
	"./mobileClient/loading.gif": "6f54",
	"./mobileClient/my.png": "9bbd",
	"./mobileClient/navIcon.png": "834d",
	"./mobileClient/policyService.png": "713f",
	"./mobileClient/policy_banner.jpg": "6cf6",
	"./mobileClient/specialization.jpg": "d652",
	"./mobileClient/us_banner.jpg": "beb4",
	"./mobileClient/weizhi.svg": "ecb8",
	"./mobileClient/xingye.svg": "9499",
	"./myCenter/NumberTransactions.png": "3411",
	"./myCenter/affirm.png": "ad3c",
	"./myCenter/alert.png": "c321",
	"./myCenter/amendIcon.png": "365d",
	"./myCenter/authenticationBlue.png": "67cf",
	"./myCenter/authenticationGreen.png": "c6e1",
	"./myCenter/authenticationOrange.png": "7941",
	"./myCenter/authenticationRed.png": "e90a",
	"./myCenter/banner.jpg": "22ee",
	"./myCenter/bannerRed.jpg": "18af",
	"./myCenter/businessLicense1.png": "2d91",
	"./myCenter/businessLicense2.png": "08f2",
	"./myCenter/cancel.png": "8f99",
	"./myCenter/check.png": "92e5",
	"./myCenter/clearPhoto.png": "8976",
	"./myCenter/dataReport.png": "7b2e",
	"./myCenter/dataproduct.png": "aa5d",
	"./myCenter/failAudit.png": "448a",
	"./myCenter/failAuditBlue.png": "d96f",
	"./myCenter/failAuditGreen.png": "b171",
	"./myCenter/failAuditOrange.png": "aa26",
	"./myCenter/failAuditRed.png": "e292",
	"./myCenter/finishChecked.png": "eeed",
	"./myCenter/finishChecked2.png": "449a",
	"./myCenter/finishChecked3.png": "d262",
	"./myCenter/finishChecked4.png": "c796",
	"./myCenter/icon1.png": "0726",
	"./myCenter/icon2.png": "712d",
	"./myCenter/icon3.png": "f6c7",
	"./myCenter/icon4.png": "e237",
	"./myCenter/identityChecked.png": "2ae5",
	"./myCenter/identityChecked2.png": "279d",
	"./myCenter/identityChecked3.png": "b9cd",
	"./myCenter/identityChecked4.png": "7058",
	"./myCenter/integralBG1.png": "8dc6",
	"./myCenter/integralBG2.png": "a826",
	"./myCenter/integralBG3.png": "ce8f",
	"./myCenter/integralIcon1.png": "7131",
	"./myCenter/integralIcon2.png": "3ea9",
	"./myCenter/integralIcon3.png": "8e5d",
	"./myCenter/loginPasswordBlue.png": "4b19",
	"./myCenter/loginPasswordGreen.png": "4478",
	"./myCenter/loginPasswordOrange.png": "b489",
	"./myCenter/loginPasswordRed.png": "18ad",
	"./myCenter/mobilePhoneBlue.png": "5950",
	"./myCenter/mobilePhoneGreen.png": "f408",
	"./myCenter/mobilePhoneOrange.png": "1d124",
	"./myCenter/mobilePhoneRed.png": "2d78",
	"./myCenter/notFinish.png": "35d7",
	"./myCenter/notFinish2.png": "0c50",
	"./myCenter/notFinish3.png": "691f",
	"./myCenter/notFinish4.png": "40ec",
	"./myCenter/picture.jpg": "f87a",
	"./myCenter/pictureRed.jpg": "609a",
	"./myCenter/rejectedBlue.png": "6c4b",
	"./myCenter/rejectedGreen.png": "b188",
	"./myCenter/rejectedOrange.png": "4766",
	"./myCenter/rejectedRed.png": "21ae",
	"./myCenter/safetyShieldBlue.png": "d69b",
	"./myCenter/safetyShieldGreen.png": "5bbb",
	"./myCenter/safetyShieldOrange.png": "5671",
	"./myCenter/safetyShieldRed.png": "7855",
	"./myCenter/set.png": "150d",
	"./myCenter/set2.png": "6f9a",
	"./myCenter/set3.png": "6150",
	"./myCenter/set4.png": "d424",
	"./myCenter/setChecked.png": "792f",
	"./myCenter/setChecked2.png": "65d5",
	"./myCenter/setChecked3.png": "f121",
	"./myCenter/setChecked4.png": "3e56",
	"./myCenter/status1.png": "6e9d",
	"./myCenter/status2.png": "e87f",
	"./myCenter/status3.png": "c8ea",
	"./myCenter/status4.png": "9ec9",
	"./myCenter/status5.png": "f380",
	"./myCenter/succeed.png": "4567",
	"./myCenter/tetragonalIntegrity.png": "234e",
	"./myCenter/triangleBlue.png": "0bbd",
	"./myCenter/triangleGreen.png": "3906",
	"./myCenter/triangleOrange.png": "3388",
	"./myCenter/triangleRed.png": "2484",
	"./myCenter/triangledBlue.png": "772e",
	"./myCenter/triangledGreen.png": "121c",
	"./myCenter/triangledOrange.png": "fe6e",
	"./myCenter/triangledRed.png": "21fa",
	"./myCenter/turnover.png": "32446",
	"./myCenter/underReview.png": "b9ba",
	"./myCenter/uniformIllumination.png": "1d12",
	"./myCenter/upIcon.png": "2595",
	"./news/bannerBlue.jpg": "de5f",
	"./news/bannerGreen.jpg": "ff9f",
	"./news/bannerOrange.jpg": "6f61",
	"./news/bannerRed.jpg": "d36f",
	"./news/detBannerBlue.jpg": "cf3f",
	"./news/detBannerGreen.jpg": "ec785",
	"./news/detBannerOrange.jpg": "ce96",
	"./news/detBannerRed.jpg": "f61e",
	"./nothingBlue.png": "de17",
	"./nothingGreen.png": "200d",
	"./nothingOrange.png": "fa26",
	"./nothingRed.png": "2147",
	"./numberQuotient/arrowsBlue.png": "eef9",
	"./numberQuotient/arrowsGreen.png": "4538",
	"./numberQuotient/arrowsOrange.png": "995d",
	"./numberQuotient/arrowsRed.png": "9d224",
	"./numberQuotient/banner.png": "08e1",
	"./numberQuotient/bannerRed.jpg": "30a7",
	"./numberQuotient/businessModel1.png": "06ac",
	"./numberQuotient/businessModel2.png": "9eee",
	"./numberQuotient/businessModel3.png": "0c0d",
	"./numberQuotient/businessModelRed1.jpg": "e948",
	"./numberQuotient/businessModelRed2.jpg": "0fe2",
	"./numberQuotient/businessModelRed3.jpg": "1379",
	"./numberQuotient/costValue.png": "785a",
	"./numberQuotient/costValueRed.jpg": "72d5",
	"./numberQuotient/digitalEvaluationBanner.jpg": "2b2db",
	"./numberQuotient/digitalEvaluationBannerRed.jpg": "8488",
	"./numberQuotient/experienceValue.jpg": "af03",
	"./numberQuotient/experienceValueRed.jpg": "4995",
	"./numberQuotient/platformValue.png": "94f6",
	"./numberQuotient/platformValueRed.jpg": "4ee8",
	"./numberQuotient/praise.png": "528f",
	"./numberQuotient/score.png": "8a6e8",
	"./numberQuotient/sideBlue.png": "8238",
	"./numberQuotient/sideGreen.png": "eec9",
	"./numberQuotient/sideOrange.png": "ab62",
	"./numberQuotient/sideRed.png": "ff73",
	"./numberQuotient/testResultsBanner.png": "3846",
	"./numberQuotient/testResultsBannerRed.jpg": "6999",
	"./onlineConsult.png": "7f33",
	"./professionalReport/0.png": "0de2",
	"./professionalReport/1.png": "4893",
	"./professionalReport/11.png": "c26d",
	"./professionalReport/12.png": "04cb",
	"./professionalReport/13.png": "6a03",
	"./professionalReport/2.png": "b456",
	"./professionalReport/3.png": "72b1",
	"./professionalReport/4.png": "9c6b",
	"./professionalReport/5.png": "e286",
	"./professionalReport/6.png": "8e61",
	"./professionalReport/7.png": "957e",
	"./professionalReport/8.png": "cb13",
	"./professionalReport/9.png": "c5cd",
	"./professionalReport/aaa.png": "cfbd",
	"./professionalReport/absoluteValuation.png": "7007",
	"./professionalReport/absoluteValuationData.png": "6322",
	"./professionalReport/absoluteValuationIcon.png": "da9c",
	"./professionalReport/bb.png": "0294",
	"./professionalReport/beveling1.png": "8eca",
	"./professionalReport/beveling2.png": "c0a9",
	"./professionalReport/beveling3.png": "4234",
	"./professionalReport/beveling4.png": "4598",
	"./professionalReport/beveling5.png": "c1cf",
	"./professionalReport/beveling6.png": "6fa0",
	"./professionalReport/bevelingbj1.png": "2c3f",
	"./professionalReport/bevelingbj2.png": "c54a",
	"./professionalReport/bevelingbj3.png": "33d2",
	"./professionalReport/bevelingbj4.png": "b33a",
	"./professionalReport/bevelingbj5.png": "1942",
	"./professionalReport/bevelingbj6.png": "d194",
	"./professionalReport/capm.png": "4e03",
	"./professionalReport/catalogue_.png": "1ced",
	"./professionalReport/cc.png": "c1a1",
	"./professionalReport/columnarIcon1.png": "9706",
	"./professionalReport/columnarIcon2.png": "4de1",
	"./professionalReport/columnarIcon3.png": "4fbc",
	"./professionalReport/columnarIcon4.png": "3b5e",
	"./professionalReport/columnarIcon5.png": "b998",
	"./professionalReport/dd.png": "0b3b",
	"./professionalReport/decline.jpg": "6380",
	"./professionalReport/decline.png": "fdc6",
	"./professionalReport/dianchi-100.png": "d4bd",
	"./professionalReport/dianchi-20.png": "f4b5",
	"./professionalReport/dianchi-40.png": "b845",
	"./professionalReport/dianchi-60.png": "a95a",
	"./professionalReport/dianchi-80.png": "cef8",
	"./professionalReport/dottedPicX.png": "9136",
	"./professionalReport/dupontAnalyze.jpg": "b13c",
	"./professionalReport/dupontAnalyze.png": "4caf",
	"./professionalReport/equityStructureBase.jpg": "3516",
	"./professionalReport/fcff.png": "04e3",
	"./professionalReport/financialAnalysisIcon.png": "349e",
	"./professionalReport/financialExamination/debtPayingAbility1.png": "92e3",
	"./professionalReport/financialExamination/debtPayingAbility10.png": "3c54",
	"./professionalReport/financialExamination/debtPayingAbility2.png": "e8bc",
	"./professionalReport/financialExamination/debtPayingAbility3.png": "5285",
	"./professionalReport/financialExamination/debtPayingAbility4.png": "a9ad",
	"./professionalReport/financialExamination/debtPayingAbility5.png": "7bc9",
	"./professionalReport/financialExamination/debtPayingAbility6.png": "0b94",
	"./professionalReport/financialExamination/debtPayingAbility7.png": "8c79",
	"./professionalReport/financialExamination/debtPayingAbility8.png": "41c5",
	"./professionalReport/financialExamination/debtPayingAbility9.png": "4ae3",
	"./professionalReport/financialExamination/growthAbility1.png": "9047",
	"./professionalReport/financialExamination/growthAbility10.png": "8c4f4",
	"./professionalReport/financialExamination/growthAbility2.png": "6336",
	"./professionalReport/financialExamination/growthAbility3.png": "6182",
	"./professionalReport/financialExamination/growthAbility4.png": "1cba",
	"./professionalReport/financialExamination/growthAbility5.png": "8b56",
	"./professionalReport/financialExamination/growthAbility6.png": "4743",
	"./professionalReport/financialExamination/growthAbility7.png": "3c08",
	"./professionalReport/financialExamination/growthAbility8.png": "81ab",
	"./professionalReport/financialExamination/growthAbility9.png": "c412",
	"./professionalReport/financialExamination/operationCapacity1.png": "5442",
	"./professionalReport/financialExamination/operationCapacity10.png": "8e55",
	"./professionalReport/financialExamination/operationCapacity2.png": "44d3",
	"./professionalReport/financialExamination/operationCapacity3.png": "ad0c",
	"./professionalReport/financialExamination/operationCapacity4.png": "be1d",
	"./professionalReport/financialExamination/operationCapacity5.png": "2403",
	"./professionalReport/financialExamination/operationCapacity6.png": "3c1e",
	"./professionalReport/financialExamination/operationCapacity7.png": "91cd",
	"./professionalReport/financialExamination/operationCapacity8.png": "3c081",
	"./professionalReport/financialExamination/operationCapacity9.png": "f423",
	"./professionalReport/financialExamination/profitability1.png": "807e",
	"./professionalReport/financialExamination/profitability10.png": "173a",
	"./professionalReport/financialExamination/profitability2.png": "8272",
	"./professionalReport/financialExamination/profitability3.png": "ed7c",
	"./professionalReport/financialExamination/profitability4.png": "858d",
	"./professionalReport/financialExamination/profitability5.png": "3477",
	"./professionalReport/financialExamination/profitability6.png": "24c7",
	"./professionalReport/financialExamination/profitability7.png": "0618",
	"./professionalReport/financialExamination/profitability8.png": "c80e",
	"./professionalReport/financialExamination/profitability9.png": "5363",
	"./professionalReport/forecastBase.png": "a1fd",
	"./professionalReport/forecastExplain.png": "a2b1",
	"./professionalReport/formulary.png": "241f",
	"./professionalReport/industry.jpg": "00bc",
	"./professionalReport/pro-page-onePic.png": "265f",
	"./professionalReport/product.jpg": "d703",
	"./professionalReport/radarBase.jpg": "2c98",
	"./professionalReport/rc.png": "899c",
	"./professionalReport/rc.svg": "b195",
	"./professionalReport/relativeValuationBase.png": "361c",
	"./professionalReport/relativeValuationBottom.png": "3a92",
	"./professionalReport/relativeValuationDotted.png": "bce3",
	"./professionalReport/relativeValuationIcon.png": "ac76",
	"./professionalReport/relativeValuationRight.png": "46e0",
	"./professionalReport/resultItem.jpg": "cd91",
	"./professionalReport/rf.png": "4264",
	"./professionalReport/rf.svg": "5182",
	"./professionalReport/semiRing1.svg": "b4a7",
	"./professionalReport/semiRing2.svg": "3ee8",
	"./professionalReport/semiRing3.svg": "a085",
	"./professionalReport/semiRing4.svg": "a178",
	"./professionalReport/semiRing5.svg": "1683",
	"./professionalReport/semiRing6.svg": "0811",
	"./professionalReport/softTechnology.jpg": "0918",
	"./professionalReport/teamManage.jpg": "4c19",
	"./professionalReport/thirdLinkLine.png": "1d92",
	"./professionalReport/valuationGraphIcon.png": "f753",
	"./professionalReport/valuationResultBase.png": "6e37",
	"./professionalReport/valuationResultData.png": "b576",
	"./professionalReport/valuationResultFont.svg": "71fd",
	"./professionalReport/valuationResults.png": "b40b",
	"./professionalReport/valuationResultsData.png": "1e58",
	"./professionalReport/valueOperatingAssets.png": "2384",
	"./professionalReport/ventureManage.jpg": "c967",
	"./professionalReport/wacc.png": "4628",
	"./professionalReport/waccFormula.png": "5aaa",
	"./projectAnalysis/bannerBlue.jpg": "7326",
	"./projectAnalysis/bannerGreen.jpg": "4336",
	"./projectAnalysis/bannerOrange.jpg": "485b",
	"./projectAnalysis/bannerRed.jpg": "d853",
	"./projectAnalysis/multiBlue.jpg": "b938",
	"./projectAnalysis/multiGreen.jpg": "fe76",
	"./projectAnalysis/multiOrange.jpg": "4838",
	"./projectAnalysis/multiRed.jpg": "c634",
	"./projectAnalysis/oneBlue.jpg": "5705",
	"./projectAnalysis/oneDesBlue.jpg": "70e7",
	"./projectAnalysis/oneDesGreen.jpg": "6f29",
	"./projectAnalysis/oneDesOrange.jpg": "288f",
	"./projectAnalysis/oneDesRed.jpg": "f527",
	"./projectAnalysis/oneGreen.jpg": "9bbf",
	"./projectAnalysis/oneOrange.jpg": "1319",
	"./projectAnalysis/oneRed.jpg": "3f26",
	"./projectAnalysis/twoBlue.jpg": "6039",
	"./projectAnalysis/twoGreen.jpg": "91369",
	"./projectAnalysis/twoOrange.jpg": "f5f5",
	"./projectAnalysis/twoRed.jpg": "64f6",
	"./realization/bannerBlue.jpg": "08bc",
	"./realization/bannerGreen.jpg": "a174",
	"./realization/bannerOrange.jpg": "f199",
	"./realization/bannerRed.jpg": "5985",
	"./realization/detBannerBlue.jpg": "231d",
	"./realization/detBannerGreen.jpg": "d4bdf",
	"./realization/detBannerOrange.jpg": "e61c",
	"./realization/detBannerRed.jpg": "d3a3",
	"./realization/equityFinancing.png": "451d",
	"./realization/fileIconBlue.png": "3498",
	"./realization/fileIconGreen.png": "01ba",
	"./realization/fileIconOrange.png": "1eb2",
	"./realization/fileIconRed.png": "bd8c",
	"./realization/typeBlue.png": "c5e5",
	"./realization/typeGreen.png": "93bb",
	"./realization/typeOrange.png": "66e5",
	"./realization/typeRed.png": "7942",
	"./remind-01@2x.png": "da44",
	"./report/0.png": "18d3",
	"./report/1.png": "f57a",
	"./report/11.png": "0d3b",
	"./report/12.png": "7495",
	"./report/2.png": "c67c",
	"./report/3.png": "2ae4",
	"./report/4.png": "b197",
	"./report/5.png": "14e6",
	"./report/6.png": "7bba",
	"./report/7.png": "1841",
	"./report/8.png": "25bb",
	"./report/9.png": "f0c2",
	"./report/MILFormula.png": "ec6f6",
	"./report/MILFormula2.png": "55ae",
	"./report/MILFormula3.png": "dc35",
	"./report/NPCM.png": "601b",
	"./report/NPCM.svg": "c8c4",
	"./report/absoluteValuationResult.png": "a572",
	"./report/analysisGrowth.png": "8ec1",
	"./report/analysisThree.png": "eeb6",
	"./report/analysisTwo.png": "f0b3",
	"./report/arrows.png": "af45",
	"./report/basicIndex.png": "8b0e",
	"./report/basicIndexIcon.svg": "5ede",
	"./report/basicIndexScore.png": "cd16",
	"./report/bookValue.png": "56a2",
	"./report/businessName.png": "7354",
	"./report/businessValuationResults.png": "2c52",
	"./report/catalogue_.png": "c0df",
	"./report/chart.png": "14a0",
	"./report/charts.png": "2d74",
	"./report/circulationIcon.png": "81fd",
	"./report/circulationIndex.png": "3d8d",
	"./report/contribution1.png": "3caa",
	"./report/contribution2.png": "6a56",
	"./report/contribution3.png": "b560",
	"./report/contributionIcon.png": "c48a",
	"./report/costIndex.png": "6c29",
	"./report/costIndexIcon.png": "14be",
	"./report/dataAssetName.png": "f781",
	"./report/dataAssetNameSpecialty.png": "6e4b",
	"./report/earth.png": "e15a",
	"./report/economicIcon.png": "3af6",
	"./report/economicIndicators.png": "c07c",
	"./report/financeIndicators.png": "0322",
	"./report/flowData.png": "d752",
	"./report/flowData.svg": "7774",
	"./report/flowLogo.png": "d0e5",
	"./report/forecast.png": "b53c",
	"./report/forecastLeftBottom.png": "5de3",
	"./report/forecastLeftTop.png": "265b",
	"./report/forecastRightBottom.png": "05c0",
	"./report/forecastRightTop.png": "f5de",
	"./report/growthScore.png": "6766",
	"./report/icon1.png": "874c",
	"./report/icon10.png": "c0b0",
	"./report/icon11.png": "3050",
	"./report/icon12.png": "0750",
	"./report/icon13.png": "f8ff",
	"./report/icon14.png": "a8a1",
	"./report/icon15.png": "1748",
	"./report/icon16.png": "3d9c",
	"./report/icon17.png": "24e2",
	"./report/icon18.png": "9821",
	"./report/icon19.png": "cd92",
	"./report/icon2.png": "dc1f",
	"./report/icon20.png": "b20f",
	"./report/icon21.png": "2b30",
	"./report/icon22.png": "862b",
	"./report/icon23.png": "5499",
	"./report/icon24.png": "433c",
	"./report/icon25.png": "dbf4",
	"./report/icon3.png": "95d1",
	"./report/icon4.png": "019b",
	"./report/icon5.png": "553f",
	"./report/icon6.png": "15b1",
	"./report/icon7.png": "c901",
	"./report/icon8.png": "5b9e",
	"./report/icon9.png": "a014",
	"./report/indicatorCosts.png": "1222",
	"./report/line.svg": "1ec1",
	"./report/logo-06-06.png": "8532",
	"./report/machineLearning.png": "5f64",
	"./report/machineLearning.svg": "9ecc",
	"./report/machineLearningValuationResults.jpg": "5a3c",
	"./report/machineLearningValuationResults.png": "43b1",
	"./report/map@2x.png": "515c",
	"./report/miniProgram.jpg": "7f00",
	"./report/mlm.svg": "0892",
	"./report/netProfitPedestal.png": "4b5c",
	"./report/officialCustomerService.jpg": "e8ca",
	"./report/pageIndex_bg.png": "41c7",
	"./report/pageNumber.png": "3b33",
	"./report/profit.png": "89be",
	"./report/qualityIndex.png": "a474",
	"./report/qualityIndexScore.png": "df61",
	"./report/qualityIndexScore1.png": "6b4c",
	"./report/qualityIndexScore2.png": "4eb1",
	"./report/qualityIndexScore3.png": "2552",
	"./report/qualityIndexScore4.png": "4cbf",
	"./report/qualityIndexScore5.png": "ea84",
	"./report/rangeHead.png": "26df",
	"./report/relationFlow.png": "3ede",
	"./report/resourceHead.png": "1fd3",
	"./report/result.png": "17de",
	"./report/revenueForecastingBase.png": "dc996",
	"./report/riskIndicator.png": "91ad",
	"./report/riskIndicatorGrade.png": "f947",
	"./report/riskIndicatorIcon.png": "3e20",
	"./report/riskIndicatorScore.png": "0215",
	"./report/softIndicatorScore.png": "fd2a",
	"./report/softIndicators.png": "be3e",
	"./report/statement-01@2x.png": "c8ec",
	"./report/statement-01@2x.svg": "035b",
	"./report/synthesisScore.png": "1511",
	"./report/technologyBox.png": "e939",
	"./report/tencent.jpg": "3a58",
	"./report/valuationFormula.png": "8e9a",
	"./report/valuationResultDV.png": "c00f",
	"./report/valuationResultDVBox.png": "d354",
	"./report/valuationResultFast.png": "19b0",
	"./report/valuationResultSpecialty.png": "eb38",
	"./report/versoStatement.jpg": "3860",
	"./report/wechartCode.jpg": "9a8b",
	"./reportCharts/columnar1.png": "359c",
	"./reportCharts/columnar10.png": "4528",
	"./reportCharts/columnar11.png": "5a07",
	"./reportCharts/columnar12.png": "6c82",
	"./reportCharts/columnar13.png": "7ad7",
	"./reportCharts/columnar14.png": "0c33",
	"./reportCharts/columnar15.png": "3cb6",
	"./reportCharts/columnar16.png": "37bc",
	"./reportCharts/columnar17.png": "4ed7",
	"./reportCharts/columnar18.png": "7755",
	"./reportCharts/columnar19.png": "92b6",
	"./reportCharts/columnar2.png": "f75b",
	"./reportCharts/columnar20.png": "3e54",
	"./reportCharts/columnar3.png": "d248",
	"./reportCharts/columnar4.png": "6425",
	"./reportCharts/columnar5.png": "aae7",
	"./reportCharts/columnar6.png": "2ba5",
	"./reportCharts/columnar7.png": "6afe",
	"./reportCharts/columnar8.png": "03f0",
	"./reportCharts/columnar9.png": "37e4",
	"./reportCharts/multipleBottom.png": "11a3",
	"./reportCharts/multipleTops.png": "fb6e",
	"./reportCharts/oneBottom.png": "d3b9",
	"./reportCharts/oneTop.png": "6687",
	"./reportValuation/caiwufenxi.png": "858b",
	"./reportValuation/caiwuzhuangkuang.png": "e1b3",
	"./reportValuation/dianchi-100.svg": "b9a5",
	"./reportValuation/dianchi-20.svg": "d128",
	"./reportValuation/dianchi-40.svg": "ec05",
	"./reportValuation/dianchi-60.svg": "3429",
	"./reportValuation/dianchi-80.svg": "2754",
	"./reportValuation/map@2x.png": "64f3",
	"./reportValuation/pro-page-onePic.png": "3a8c",
	"./reportValuation/statement-01@2x.png": "856d",
	"./secondaryPage/data/advantage1Blue.png": "f8bd",
	"./secondaryPage/data/advantage1Green.png": "80fb",
	"./secondaryPage/data/advantage1Orange.png": "b705",
	"./secondaryPage/data/advantage1Red.png": "de10",
	"./secondaryPage/data/advantage2Blue.png": "3604",
	"./secondaryPage/data/advantage2Green.png": "0bcd",
	"./secondaryPage/data/advantage2Orange.png": "e2c5",
	"./secondaryPage/data/advantage2Red.png": "70a0",
	"./secondaryPage/data/advantage3Blue.png": "380a",
	"./secondaryPage/data/advantage3Green.png": "a245",
	"./secondaryPage/data/advantage3Orange.png": "7474",
	"./secondaryPage/data/advantage3Red.png": "5612",
	"./secondaryPage/data/advantage4Blue.png": "96e4",
	"./secondaryPage/data/advantage4Green.png": "6bc7",
	"./secondaryPage/data/advantage4Orange.png": "4585",
	"./secondaryPage/data/advantage4Red.png": "a30f",
	"./secondaryPage/data/advantage5Blue.png": "34a1",
	"./secondaryPage/data/advantage5Green.png": "75e1",
	"./secondaryPage/data/advantage5Orange.png": "57cc",
	"./secondaryPage/data/advantage5Red.png": "dab5",
	"./secondaryPage/data/advantage6Blue.png": "9c2c",
	"./secondaryPage/data/advantage6Green.png": "7fc0",
	"./secondaryPage/data/advantage6Orange.png": "0672",
	"./secondaryPage/data/advantage6Red.png": "226d",
	"./secondaryPage/data/bannerBlue.jpg": "acf6",
	"./secondaryPage/data/bannerGreen.jpg": "41d5",
	"./secondaryPage/data/bannerOrange.jpg": "e4fa",
	"./secondaryPage/data/bannerRed.jpg": "411e",
	"./secondaryPage/data/cause1Blue.png": "5a63",
	"./secondaryPage/data/cause1Green.png": "31de",
	"./secondaryPage/data/cause1Orange.png": "99eb",
	"./secondaryPage/data/cause1Red.png": "7958",
	"./secondaryPage/data/cause2Blue.png": "4c70",
	"./secondaryPage/data/cause2Green.png": "20bb",
	"./secondaryPage/data/cause2Orange.png": "519d",
	"./secondaryPage/data/cause2Red.png": "2b66",
	"./secondaryPage/data/cause3Blue.png": "8478",
	"./secondaryPage/data/cause3Green.png": "dd73",
	"./secondaryPage/data/cause3Orange.png": "0572",
	"./secondaryPage/data/cause3Red.png": "a569",
	"./secondaryPage/data/cause4Blue.png": "76c0",
	"./secondaryPage/data/cause4Green.png": "6da0",
	"./secondaryPage/data/cause4Orange.png": "c5c4",
	"./secondaryPage/data/cause4Red.png": "f163",
	"./secondaryPage/data/four1Blue.jpg": "a47aa",
	"./secondaryPage/data/four1Green.jpg": "d0c7",
	"./secondaryPage/data/four1Orange.jpg": "4154",
	"./secondaryPage/data/four1Red.jpg": "9a75",
	"./secondaryPage/data/four2Blue.jpg": "8aab",
	"./secondaryPage/data/four2Green.jpg": "4559",
	"./secondaryPage/data/four2Orange.jpg": "0a3d",
	"./secondaryPage/data/four2Red.jpg": "cfa0",
	"./secondaryPage/data/four3Blue.jpg": "fc71",
	"./secondaryPage/data/four3Green.jpg": "8f55",
	"./secondaryPage/data/four3Orange.jpg": "68eb",
	"./secondaryPage/data/four3Red.jpg": "bbb7",
	"./secondaryPage/data/four4Blue.jpg": "85df",
	"./secondaryPage/data/four4Green.jpg": "9fb1",
	"./secondaryPage/data/four4Orange.jpg": "56fd",
	"./secondaryPage/data/four4Red.jpg": "64ea",
	"./secondaryPage/data/oneBlue.jpg": "55c7",
	"./secondaryPage/data/oneGreen.jpg": "9603",
	"./secondaryPage/data/oneOrange.jpg": "3abe",
	"./secondaryPage/data/oneRed.jpg": "5502",
	"./secondaryPage/data/three1Blue.jpg": "bdb7f",
	"./secondaryPage/data/three1Green.jpg": "652a",
	"./secondaryPage/data/three1Orange.jpg": "65f9",
	"./secondaryPage/data/three1Red.jpg": "8425",
	"./secondaryPage/data/three2Blue.jpg": "8658",
	"./secondaryPage/data/three2Green.jpg": "e741",
	"./secondaryPage/data/three2Orange.jpg": "0efc",
	"./secondaryPage/data/three2Red.jpg": "cd639",
	"./secondaryPage/data/three3Blue.jpg": "a6a9",
	"./secondaryPage/data/three3Green.jpg": "f911",
	"./secondaryPage/data/three3Orange.jpg": "9eb1",
	"./secondaryPage/data/three3Red.jpg": "ddeb",
	"./secondaryPage/diagnose/bannerBlue.jpg": "78c2",
	"./secondaryPage/diagnose/bannerGreen.jpg": "eb02",
	"./secondaryPage/diagnose/bannerOrange.jpg": "15b8",
	"./secondaryPage/diagnose/bannerRed.jpg": "f95b",
	"./secondaryPage/diagnose/five1Blue.jpg": "7f1b",
	"./secondaryPage/diagnose/five1Green.jpg": "e942",
	"./secondaryPage/diagnose/five1Orange.jpg": "74c8",
	"./secondaryPage/diagnose/five1Red.jpg": "bfd5",
	"./secondaryPage/diagnose/five2Blue.jpg": "84d0",
	"./secondaryPage/diagnose/five2Green.jpg": "1266",
	"./secondaryPage/diagnose/five2Orange.jpg": "9560",
	"./secondaryPage/diagnose/five2Red.jpg": "8cbe",
	"./secondaryPage/diagnose/five3Blue.jpg": "0a4b",
	"./secondaryPage/diagnose/five3Green.jpg": "443e",
	"./secondaryPage/diagnose/five3Orange.jpg": "7507",
	"./secondaryPage/diagnose/five3Red.jpg": "080e",
	"./secondaryPage/diagnose/five4Blue.jpg": "070d",
	"./secondaryPage/diagnose/five4Green.jpg": "b368",
	"./secondaryPage/diagnose/five4Orange.jpg": "fad0",
	"./secondaryPage/diagnose/five4Red.jpg": "7db4",
	"./secondaryPage/diagnose/five5Blue.jpg": "23ff",
	"./secondaryPage/diagnose/five5Green.jpg": "d470",
	"./secondaryPage/diagnose/five5Orange.jpg": "50b2",
	"./secondaryPage/diagnose/five5Red.jpg": "cfda",
	"./secondaryPage/diagnose/oneBlue.jpg": "44bb",
	"./secondaryPage/diagnose/oneGreen.jpg": "edd1",
	"./secondaryPage/diagnose/oneOrange.jpg": "b80d",
	"./secondaryPage/diagnose/oneRed.jpg": "8ec6",
	"./secondaryPage/diagnose/three1Blue.jpg": "ee1d",
	"./secondaryPage/diagnose/three1Green.jpg": "ac7f",
	"./secondaryPage/diagnose/three1Orange.jpg": "f149",
	"./secondaryPage/diagnose/three1Red.jpg": "8057",
	"./secondaryPage/diagnose/three2Blue.jpg": "5b71",
	"./secondaryPage/diagnose/three2Green.jpg": "631e",
	"./secondaryPage/diagnose/three2Orange.jpg": "9354",
	"./secondaryPage/diagnose/three2Red.jpg": "2c28",
	"./secondaryPage/diagnose/three3Blue.jpg": "2bf5",
	"./secondaryPage/diagnose/three3Green.jpg": "27ee",
	"./secondaryPage/diagnose/three3Orange.jpg": "37f4",
	"./secondaryPage/diagnose/three3Red.jpg": "7db7",
	"./secondaryPage/diagnose/whyBlue.jpg": "8b5b",
	"./secondaryPage/diagnose/whyGreen.jpg": "896c",
	"./secondaryPage/diagnose/whyOrange.jpg": "ba19",
	"./secondaryPage/diagnose/whyRed.jpg": "1792",
	"./secondaryPage/funds/advantageBlue.jpg": "8a4f",
	"./secondaryPage/funds/advantageGreen.jpg": "11fa",
	"./secondaryPage/funds/advantageOrange.jpg": "89766",
	"./secondaryPage/funds/advantageRed.jpg": "e673",
	"./secondaryPage/funds/bannerBlue.jpg": "2f64",
	"./secondaryPage/funds/bannerGreen.jpg": "8db6",
	"./secondaryPage/funds/bannerOrange.jpg": "ff8b",
	"./secondaryPage/funds/bannerRed.jpg": "9ec5",
	"./secondaryPage/funds/introductionBlue.jpg": "0005",
	"./secondaryPage/funds/introductionGreen.jpg": "7dd6",
	"./secondaryPage/funds/introductionOrange.jpg": "9359",
	"./secondaryPage/funds/introductionRed.jpg": "3111",
	"./secondaryPage/funds/oneBlue.jpg": "0069",
	"./secondaryPage/funds/oneGreen.jpg": "a3cf",
	"./secondaryPage/funds/oneOrange.jpg": "d255",
	"./secondaryPage/funds/oneRed.jpg": "161a",
	"./secondaryPage/funds/three1Blue.jpg": "0e34",
	"./secondaryPage/funds/three1Green.jpg": "804e",
	"./secondaryPage/funds/three1Orange.jpg": "e32c",
	"./secondaryPage/funds/three1Red.jpg": "d260",
	"./secondaryPage/funds/three2Blue.jpg": "db6f",
	"./secondaryPage/funds/three2Green.jpg": "9202",
	"./secondaryPage/funds/three2Orange.jpg": "55ab",
	"./secondaryPage/funds/three2Red.jpg": "e2f6",
	"./secondaryPage/funds/three3Blue.jpg": "b56b",
	"./secondaryPage/funds/three3Green.jpg": "7912",
	"./secondaryPage/funds/three3Orange.jpg": "2a74",
	"./secondaryPage/funds/three3Red.jpg": "3525",
	"./secondaryPage/funds/two1Blue.jpg": "4b0e",
	"./secondaryPage/funds/two1Green.jpg": "2fef",
	"./secondaryPage/funds/two1Orange.jpg": "d182",
	"./secondaryPage/funds/two1Red.jpg": "fc70",
	"./secondaryPage/funds/two2Blue.jpg": "0d03",
	"./secondaryPage/funds/two2Green.jpg": "31f6",
	"./secondaryPage/funds/two2Orange.jpg": "ba94",
	"./secondaryPage/funds/two2Red.jpg": "1867",
	"./secondaryPage/valuation/bannerBlue.jpg": "3ec8",
	"./secondaryPage/valuation/bannerGreen.jpg": "89dc",
	"./secondaryPage/valuation/bannerOrange.jpg": "b86b",
	"./secondaryPage/valuation/bannerRed.jpg": "2d1d",
	"./secondaryPage/valuation/eight1Blue.jpg": "fa51",
	"./secondaryPage/valuation/eight1Green.jpg": "8eb4",
	"./secondaryPage/valuation/eight1Orange.jpg": "f56b",
	"./secondaryPage/valuation/eight1Red.jpg": "f39f",
	"./secondaryPage/valuation/eight2Blue.jpg": "aa2d",
	"./secondaryPage/valuation/eight2Green.jpg": "3795",
	"./secondaryPage/valuation/eight2Orange.jpg": "01c5",
	"./secondaryPage/valuation/eight2Red.jpg": "d05a",
	"./secondaryPage/valuation/eight3Blue.jpg": "d726",
	"./secondaryPage/valuation/eight3Green.jpg": "8d5b",
	"./secondaryPage/valuation/eight3Orange.jpg": "8452",
	"./secondaryPage/valuation/eight3Red.jpg": "6220",
	"./secondaryPage/valuation/eight4Blue.jpg": "a1a7",
	"./secondaryPage/valuation/eight4Green.jpg": "3126",
	"./secondaryPage/valuation/eight4Orange.jpg": "fab3",
	"./secondaryPage/valuation/eight4Red.jpg": "4977",
	"./secondaryPage/valuation/eight5Blue.jpg": "7772",
	"./secondaryPage/valuation/eight5Green.jpg": "33bd",
	"./secondaryPage/valuation/eight5Orange.jpg": "8758",
	"./secondaryPage/valuation/eight5Red.jpg": "d7eb",
	"./secondaryPage/valuation/eight6Blue.jpg": "50de",
	"./secondaryPage/valuation/eight6Green.jpg": "e4f9",
	"./secondaryPage/valuation/eight6Orange.jpg": "6f5a",
	"./secondaryPage/valuation/eight6Red.jpg": "a748",
	"./secondaryPage/valuation/eight7Blue.jpg": "6aac",
	"./secondaryPage/valuation/eight7Green.jpg": "7e79",
	"./secondaryPage/valuation/eight7Orange.jpg": "36c9",
	"./secondaryPage/valuation/eight7Red.jpg": "2d02",
	"./secondaryPage/valuation/eight8Blue.jpg": "c717",
	"./secondaryPage/valuation/eight8Green.jpg": "ff82",
	"./secondaryPage/valuation/eight8Orange.jpg": "7afd",
	"./secondaryPage/valuation/eight8Red.jpg": "9b38",
	"./secondaryPage/valuation/methodBlue.jpg": "f60c",
	"./secondaryPage/valuation/methodGreen.jpg": "dd11",
	"./secondaryPage/valuation/methodOrange.jpg": "23dd",
	"./secondaryPage/valuation/methodRed.jpg": "408e",
	"./secondaryPage/valuation/modelBlue.jpg": "76ff",
	"./secondaryPage/valuation/modelGreen.jpg": "b7f0",
	"./secondaryPage/valuation/modelOrange.jpg": "dc90",
	"./secondaryPage/valuation/modelRed.jpg": "dc09",
	"./secondaryPage/valuation/oneBlue.jpg": "16a9",
	"./secondaryPage/valuation/oneGreen.jpg": "8513",
	"./secondaryPage/valuation/oneOrange.jpg": "9c3a",
	"./secondaryPage/valuation/oneRed.jpg": "ea59",
	"./secondaryPage/valuation/targetBlue.jpg": "8a6c",
	"./secondaryPage/valuation/targetGreen.jpg": "148d",
	"./secondaryPage/valuation/targetOrange.jpg": "1290",
	"./secondaryPage/valuation/targetRed.jpg": "75f0",
	"./secondaryPage/valuation/three1Blue.jpg": "e99c",
	"./secondaryPage/valuation/three1Green.jpg": "4ba7",
	"./secondaryPage/valuation/three1Orange.jpg": "b324",
	"./secondaryPage/valuation/three1Red.jpg": "37c1",
	"./secondaryPage/valuation/three2Blue.jpg": "be04",
	"./secondaryPage/valuation/three2Green.jpg": "9258",
	"./secondaryPage/valuation/three2Orange.jpg": "4907",
	"./secondaryPage/valuation/three2Red.jpg": "2db4",
	"./secondaryPage/valuation/three3Blue.jpg": "0e58",
	"./secondaryPage/valuation/three3Green.jpg": "5166f",
	"./secondaryPage/valuation/three3Orange.jpg": "d509",
	"./secondaryPage/valuation/three3Red.jpg": "5997",
	"./secondaryPage/valuation/whyBlue.jpg": "196e",
	"./secondaryPage/valuation/whyGreen.jpg": "baa6",
	"./secondaryPage/valuation/whyOrange.jpg": "4463",
	"./secondaryPage/valuation/whyRed.jpg": "5358",
	"./securitization.png": "51c9",
	"./softIndex/arrows.png": "0dc0",
	"./softIndex/circulateBlue.png": "fc30",
	"./softIndex/circulateGreen.png": "c3ae",
	"./softIndex/circulateOrange.png": "1ee7",
	"./softIndex/costBlue.png": "da4c",
	"./softIndex/costGreen.png": "049d",
	"./softIndex/costOrange.png": "daef",
	"./softIndex/desc-tip@2x.png": "82d2",
	"./softIndex/economicsBlue.png": "8458",
	"./softIndex/economicsGreen.png": "4b0a",
	"./softIndex/economicsOrange.png": "d7e9",
	"./softIndex/infoBlue.png": "f313",
	"./softIndex/infoGreen.png": "bf83",
	"./softIndex/infoOrange.png": "d685",
	"./softIndex/play.png": "de3c",
	"./softIndex/qualityBlue.png": "57d5",
	"./softIndex/qualityGreen.png": "3a18",
	"./softIndex/qualityOrange.png": "0985",
	"./softIndex/riskBlue.png": "2d03a",
	"./softIndex/riskGreen.png": "7734",
	"./softIndex/riskOrange.png": "a7b7",
	"./softIndex/selectedQuestion.png": "4e42",
	"./softIndex/softPedestal.png": "12eb",
	"./softIndex/title.png": "31c5",
	"./softIndex/triangle.png": "3827",
	"./softIndex/unselectedQuestion.png": "10fc",
	"./startup/cyberlook.png": "7831",
	"./startup/edge.svg": "20fe",
	"./startup/expenditureItem.svg": "c4f4",
	"./startup/expenditureItemIcon1.png": "473b",
	"./startup/expenditureItemIcon2.png": "f419",
	"./startup/expenditureItemIcon3.png": "e804",
	"./startup/expenditureItemIcon4.png": "fb22",
	"./startup/expenditureItemIcon5.png": "c659",
	"./startup/expenditureItemIcon6.png": "7525",
	"./startup/flowIndex.png": "9a06",
	"./startup/flowIndexCircle.png": "d052",
	"./startup/forecastIcon.png": "bb43",
	"./startup/keyVisual.svg": "aeaf",
	"./startup/priceMethod.png": "286d",
	"./startup/resultCircle.png": "4211",
	"./startup/resultCircleSide.png": "efb0",
	"./startup/startupValuationResult.png": "05a3",
	"./tableEntryService/caseBanner.jpg": "eb18",
	"./tableEntryService/designBanner.jpg": "d6f7",
	"./tableEntryService/docx.png": "a4b3",
	"./tableEntryService/feature1.png": "85a0",
	"./tableEntryService/feature2.png": "3bd8",
	"./tableEntryService/feature3.png": "8945",
	"./tableEntryService/introduceIcon1.png": "c2dd",
	"./tableEntryService/introduceIcon2.png": "354b",
	"./tableEntryService/introduceIcon3.png": "ceec",
	"./tableEntryService/introduceImg.png": "a661",
	"./tableEntryService/kernel.png": "aff2",
	"./tableEntryService/loading.gif": "06f3",
	"./tableEntryService/pdf.png": "f253",
	"./tableEntryService/plusSign.png": "fea0",
	"./tableEntryService/qaBanner.jpg": "8ffb",
	"./tableEntryService/su.png": "a600",
	"./tableEntryService/suHalf.png": "aad0",
	"./tableEntryService/up.png": "6cca",
	"./tableEntryService/userBlue.png": "6baa",
	"./tableEntryService/userGreen.png": "0d26",
	"./tableEntryService/userOrange.png": "7ab6",
	"./tableEntryService/userRed.png": "a8c5",
	"./tableEntryService/xlsx.png": "9ad4",
	"./资讯详情.png": "3a44"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";